import { pipe } from "fp-ts/function";
import { gunshotsTable } from "../domain/timing";
import { pick } from "../utils/fp";
import * as t from "io-ts";
import { EventId } from "../domain/event";
import { useQuery } from "../utils/supabase/useQuery";
import { column, columns } from "../utils/pg-ts/pg-ts";
import { Nullable } from "../utils/types";

const gunshotColumns = pipe(gunshotsTable.columns, pick("gunshot", "id"));
const gunshotCodec = t.type(gunshotColumns, "Gunshot");
export type Gunshot = t.TypeOf<typeof gunshotCodec>;

export const useEventGunShots = (eventId: Nullable<EventId>) => {
    const shouldSkip = eventId == null;

    return useQuery(
        `gunshots_${eventId}`,
        (supabase) =>
            supabase
                .from(gunshotsTable.name)
                .select(columns(gunshotColumns))
                .eq(column(gunshotsTable, "event_id"), eventId),
        t.array(gunshotCodec),
        {
            refreshInterval: 10000,
        },
        shouldSkip
    );
};
